const baseURL: string = "https://mycdirapi.azurewebsites.net/api/";
const domain: string = "https://mycdirapi.azurewebsites.net";
const ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
const appName: string = "CDIR";
const appId: string = "2"

export default baseURL;
export { domain, ticketBaseURL, appName, appId };